export default __webpack_public_path__ + "static/media/technologies-hero.9e25f187.svg";